// Mirror contract-side checks so the UI can pre-validate.
import { toNumberSafe } from './format';

export function validateInvestment(amountStr, limits) {
  const min = limits && limits.min ? toNumberSafe(limits.min) : 50;
  const mult = limits && limits.multiple ? toNumberSafe(limits.multiple) : 50;
  const val = Number(amountStr);
  if (!isFinite(val) || val <= 0) return 'Enter a valid amount.';
  if (val < min) return `Minimum investment is $${min}.`;
  if (Math.abs(val % mult) > 1e-9) return `Amount must be a multiple of $${mult}.`;
  return null;
}

export function validateClaim(amountStr, pending, minClaim) {
  const val = Number(amountStr);
  const p = toNumberSafe(pending);
  const m = toNumberSafe(minClaim || 10);
  if (val === 0) {
    if (p < m) return `Pending is below the $${m} minimum claim.`;
    return null;
  }
  if (!isFinite(val) || val < 0) return 'Enter a valid amount.';
  if (val < m) return `Minimum claim is $${m}.`;
  if (val > p) return 'Amount exceeds pending balance.';
  return null;
}
